<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/Facilities/Keys">Facilities</b-breadcrumb-item>
            <b-breadcrumb-item to="/Facilities/Keys">Keys</b-breadcrumb-item>
            <b-breadcrumb-item :to="{name:'KeyDetails',params:{id:facilitiesKeyId,keyNumber:facilitiesKeyNumber}}">{{facilitiesKeyNumber}}</b-breadcrumb-item>
            <b-breadcrumb-item active>Edit Lock</b-breadcrumb-item>
        </b-breadcrumb>

        <form @submit.prevent="onSubmit()">
            <div class="card">
                <div class="bg-dark card-header text-white">Edit Lock</div>
                <div class="card-body">
                    <div class="pb-3">
                        <b>Key Type:</b> {{ facilitiesKeyTypeName }}
                    </div>
                    <div class="row pb-3">
                        <div v-if="lockType !== null" class="col-12 col-sm-5 col-md-3">
                            <b>Lock Types:</b> {{ lockType }}
                        </div>
                        <div v-if="buildingName !== null || spaceType !== null || spaceIdentity !== null" class="col-12 col-sm-5 col-md-3">
                            <b>Lock For:</b> {{ buildingName }} {{ spaceType }} {{ spaceIdentity }}
                        </div>
                    </div>
                    <div v-if="lockIdentity !== null" class="pb-3">
                        <b>Lock Notes/Name/Location:</b> {{ lockIdentity }}
                    </div>
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-4">
                            <label for="notes">Additional Notes</label>
                            <textarea class="form-control"
                                        maxlength="1000"
                                        v-model="notes"/>
                        </div>
                    </div>
                </div>
                <div class="card-footer d-print-none text-right">
                    <button :disabled="isSubmitting || rangeEnabled" class="btn btn-primary" type="submit">Save</button>
                    <RouterLink :to="{name:'KeyDetails',params:{id:facilitiesKeyId,keyNumber:facilitiesKeyNumber}}" class="btn btn-danger">Back</RouterLink>
                </div>
            </div>
        </form>

    </div>
</template>

<script>
    import {ToastType} from "@/services/models/shared/ToastType";
    import FacilitiesKeysService from "@/services/FacilitiesKeysService";

    export default {
        props: {
            id: {
              type: String,
              required: true
            },
            facilitiesKeyId: {
              type: String,
              required: true
            },
            facilitiesKeyNumber: {
              type: String,
              required: true
            },
            facilitiesKeyTypeName: {
              type: String,
              required: true
            },
            facilitiesKeyTypeId: {
              type: String,
              required: true
            }
        },
        data() {
            return {
                isSubmitting: false,
                lockType: null,
                buildingName: null,
                spaceType: null,
                spaceIdentity: null,
                lockIdentity: null,
                notes: null
            }
        },
        methods: {
            loadData() {
                const vm = this;

                FacilitiesKeysService.getFacilitiesKeyLock(this.id)
                    .then(response => {
                        vm.lockType = response.lockType;
                        vm.buildingName = response.buildingName;
                        vm.spaceType = response.spaceType;
                        vm.spaceIdentity = response.spaceIdentity;
                        vm.lockIdentity = response.lockIdentity;
                        vm.notes = response.notes;
                    })
                    .catch((error) => {
                      vm.alert(ToastType.Danger, error.response.data)
                      // Redirect to the key detail page
                      vm.$router.replace({name:'KeyDetails',params:{id:vm.facilitiesKeyId,keyNumber:vm.facilitiesKeyNumber}});
                    })
            },

            /**
             * @description Updates a lock and redirects if successful
             */
            onSubmit() {
                const vm = this;

                vm.isSubmitting = true;
                FacilitiesKeysService.updateFacilitiesKeyLock(this.id, {
                    notes: this.notes,
                    lastModifiedByPersonId: this.$store.getters.user.id
                })
                    .then(() => {
                      vm.alert(ToastType.Success, "The key lock was successfully update");

                      // Redirect to the key detail page
                      vm.$router.replace({name:'KeyDetails',params:{id:vm.facilitiesKeyId,keyNumber:vm.facilitiesKeyNumber}})
                    })
                    .catch((error) => {
                      vm.alert(ToastType.Danger, error.response.data)
                    })
                    .finally(() => {
                      vm.isSubmitting = false;
                    })
            }
        },
        created () {
            this.loadData();
        }
    }
</script>
